const Alert = {
  baseStyle: {
    container: {
      paddingY: 4,
      paddingX: 4,
      borderRadius: "lg",
    },
  },
  variants: {
    "left-accent": ({ colorScheme }) => ({
      container: {
        color: "gray.700",
        bg: "white",
        shadow: "md",
        paddingY: 4,
        paddingX: 4,
        borderLeft: "none",
        "::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "5px",
          bg: `${colorScheme}.500`,
        },
      },
      icon: {
        marginEnd: 1,
        marginStart: 2,
      },
      description: {
        marginStart: 2,
      },
    }),
  },
};

export default Alert;
